/* sb-typewriter.js — the house typewriter reveal for a headline's closing
   accent phrase. Any element marked [data-sb-type] is split into per-character
   spans that stay in the DOM, so the headline's wrapping (and centring, where
   it is centred) never shifts; the characters reveal in order the moment the
   line enters view, with a blinking caret tracking the write head. Words are
   wrapped so they never break mid-word.

   Progressive enhancement: without JS the phrase renders as plain text (the
   sections gate the pre-JS flash behind .sb-js); under reduced motion, or
   without IntersectionObserver, the whole phrase is shown at once.

   Shared file — each section supplies its own .sb-type__char / .sb-type__caret
   styling so the effect inherits that headline's ink. Extracted from
   sb-manifesto.js (2026-08-15) when the rating-distribution band took the same
   reveal on "Here is the whole shape." */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(el) {
    if (el.dataset.sbTypeInit) return;
    el.dataset.sbTypeInit = 'true';

    var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text) return;
    el.textContent = '';

    /* Build word > char spans; spaces between words are plain (breakable) text. */
    var chars = [];
    var words = text.split(' ');
    words.forEach(function (word, wi) {
      var wspan = document.createElement('span');
      wspan.className = 'sb-type__word';
      for (var i = 0; i < word.length; i++) {
        var c = document.createElement('span');
        c.className = 'sb-type__char';
        c.textContent = word.charAt(i);
        wspan.appendChild(c);
        chars.push(c);
      }
      el.appendChild(wspan);
      if (wi < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    el.classList.add('is-type-ready');

    if (reduce || !('IntersectionObserver' in window)) {
      chars.forEach(function (c) { c.classList.add('is-on'); });
      return;
    }

    var caret = document.createElement('span');
    caret.className = 'sb-type__caret';
    caret.setAttribute('aria-hidden', 'true');
    el.insertBefore(caret, el.firstChild);
    el.classList.add('is-typing');

    var started = false;
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !started) {
        started = true;
        io.disconnect();
        run();
      }
    }, { threshold: 0 });
    io.observe(el);

    function run() {
      var i = 0;
      (function step() {
        if (i >= chars.length) {
          el.classList.remove('is-typing');
          el.classList.add('is-typed');
          window.setTimeout(function () {
            if (caret.parentNode) caret.parentNode.removeChild(caret);
          }, 800);
          return;
        }
        var c = chars[i];
        c.classList.add('is-on');
        /* Park the caret right after the just-typed character. */
        if (c.nextSibling) c.parentNode.insertBefore(caret, c.nextSibling);
        else c.parentNode.appendChild(caret);
        i++;
        window.setTimeout(step, 40 + Math.random() * 45);
      })();
    }
  }

  function boot(root) {
    var els = (root || document).querySelectorAll('[data-sb-type]');
    for (var i = 0; i < els.length; i++) setup(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
